var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaContentLoadingBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 55,
    viewBox: "0 0 58 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6386 0.242125C18.4483 1.12081 14.9339 3.35882 12.9302 7.14822C9.34031 13.9376 10.8674 18.9067 9.61203 23.9236C8.35661 28.9405 4.50765 30.6221 1.73934 34.5488C-0.421448 37.6137 -0.762774 45.0688 3.10951 48.7912C6.94047 52.4447 10.4732 55.8323 17.3513 54.8001C24.1605 53.8092 27.5936 49.2201 34.7475 47.7883C41.9014 46.3564 47.8265 47.6674 51.6335 44.2696C55.6256 40.7067 59.7783 30.8522 56.2113 23.7395C53.3422 18.0184 46.3663 16.7375 42.963 11.375C39.5597 6.01254 37.9269 3.62471 34.9915 2.34246C30.9335 0.569826 27.8799 -0.475896 23.6386 0.242125Z",
    fill: "#90734F",
    fillOpacity: 0.08
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaContentLoadingBackground);
export default __webpack_public_path__ + "static/media/media-content-loading-background.90c5927d40a69b609194791db2693441.svg";
export { ForwardRef as ReactComponent };